var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UploadedFile } from '../uploaded-file';
export function readUploadedFolders(entries) {
    return __awaiter(this, void 0, void 0, function () {
        var files, _a, _b, _i, key, entry, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    files = [];
                    _a = [];
                    for (_b in entries)
                        _a.push(_b);
                    _i = 0;
                    _g.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 6];
                    key = _a[_i];
                    entry = entries[key];
                    if (!!entry.isDirectory) return [3 /*break*/, 3];
                    _d = (_c = files).push;
                    return [4 /*yield*/, transformFileEntry(entry)];
                case 2:
                    _d.apply(_c, [_g.sent()]);
                    return [3 /*break*/, 5];
                case 3:
                    _f = (_e = files).concat;
                    return [4 /*yield*/, readDirRecursive(entry)];
                case 4:
                    files = _f.apply(_e, [_g.sent()]);
                    _g.label = 5;
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/, files];
            }
        });
    });
}
function readDirRecursive(entry, files) {
    if (files === void 0) { files = []; }
    return __awaiter(this, void 0, void 0, function () {
        var entries, _a, _b, _i, key, childEntry, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, readEntries(entry)];
                case 1:
                    entries = _e.sent();
                    _a = [];
                    for (_b in entries)
                        _a.push(_b);
                    _i = 0;
                    _e.label = 2;
                case 2:
                    if (!(_i < _a.length)) return [3 /*break*/, 7];
                    key = _a[_i];
                    childEntry = entries[key];
                    if (!childEntry.isDirectory) return [3 /*break*/, 4];
                    return [4 /*yield*/, readDirRecursive(childEntry, files)];
                case 3:
                    _e.sent();
                    return [3 /*break*/, 6];
                case 4:
                    _d = (_c = files).push;
                    return [4 /*yield*/, transformFileEntry(childEntry)];
                case 5:
                    _d.apply(_c, [_e.sent()]);
                    _e.label = 6;
                case 6:
                    _i++;
                    return [3 /*break*/, 2];
                case 7: return [2 /*return*/, files];
            }
        });
    });
}
function readEntries(dir) {
    return new Promise(function (resolve) {
        var reader = dir.createReader();
        reader.readEntries(function (entries) { return resolve(entries); });
    });
}
function transformFileEntry(entry) {
    return new Promise(function (resolve) {
        entry.file(function (file) {
            resolve(new UploadedFile(file, entry.fullPath));
        });
    });
}
